"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CLIUtils {
    static getUserConfig(configPath) {
        let config;
        try {
            config = require(configPath);
        }
        catch (_a) {
            try {
                config = __non_webpack_require__(configPath);
            }
            catch (_b) {
                throw new ReferenceError('Given config path must be a valid `.js` or `.json` file path');
            }
        }
        return config;
    }
}
exports.CLIUtils = CLIUtils;
